export default function RowIconAction({ label, icon: Icon, onClick, danger = false, disabled = false, busy = false }) {
  const className = [
    "icon-action",
    danger && "icon-action-danger",
    busy && "icon-action-busy",
  ].filter(Boolean).join(" ");

  return (
    <button type="button" className={className} title={label} aria-label={label} onClick={onClick} disabled={disabled}>
      <Icon size={16} strokeWidth={1.8} aria-hidden="true" />
    </button>
  );
}